import { render, staticRenderFns } from "./notification-IssueCommented.vue?vue&type=template&id=31d9e7c6&scoped=true"
import script from "./notification-IssueCommented.vue?vue&type=script&lang=js"
export * from "./notification-IssueCommented.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9e7c6",
  null
  
)

export default component.exports